import * as React from "react";

import ManageUsersRequested from "../ManageUsersRequested";

const UsersRequestedPanel: React.FC = () => {
	return <ManageUsersRequested />;
};

export default UsersRequestedPanel;
